
import { useMutation } from "@tanstack/react-query";
import { LoginApi } from "./api.js";

export const useLogin = () => {
    return useMutation({
        mutationFn: LoginApi,
    });
};
import {
  ChangeAdminPasswordApi,
  type ChangeAdminPasswordPayload,
} from "./api.js";
import { toastify } from "../../../../components/ui/Toasts/index.js";

export const useChangeAdminPassword = () => {
  return useMutation({
    mutationFn: (payload: ChangeAdminPasswordPayload) =>
      ChangeAdminPasswordApi(payload),
    onSuccess: (res: any) => {
      if (res?.hasError) {
        toastify("error", res?.message || "خطا در تغییر پسورد");
        return;
      }
      toastify("success", "پسورد با موفقیت تغییر کرد");
    },
    onError: (error: any) => {
      toastify(
        "error",
        error?.response?.data?.message || "خطا در تغییر پسورد"
      );
    },
  });
};